<template>
    <a-modal v-model="attachCfg.visible" :title="title" centered :maskClosable="false" :keyboard="false" @ok="handleOk" width="40%" class="diyModelCls">
        <div class="attactpanel">
            <div class="attachtitle">
                附件浏览
                <div class="attachicon"><a-icon type="download" /></div>
            </div>
            <div class="attachserch"><a-input-search v-model="searchvalue" placeholder="请输入文件名" style="width: 27.5%;" @search="onSearch" /></div>
            <div class="attachfilelist">
                <vxe-table
                    ref="itemTable"
                    size="mini"
                    resizable
                    keep-source
                    auto-resize
                    row-id="id"
                    align="left"
                    header-align="center"
                    highlight-hover-row
                    show-overflow="tooltip"
                    :data="fileList"
                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="filename" title="文件"></vxe-table-column>
                    <vxe-table-column title="操作" width="120" align="center">
                        <template v-slot="scope">
                            <span class="btn_edit" @click="handlePreview(scope.row)"><a-icon type="link" />预览</span>
                            <span class="btn_edit" @click="handleDownload(scope.row)"><a-icon type="download" />下载</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: "AttachModalDownload",
    props: ["attachCfg"],
    data() {
        return {
            queryParams: {},
            searchvalue: "",
            fileList: [],
            file: {}
        };
    },
    computed: {
        title() {
            return "附件管理";
        },
        // 是否显示界面
        editVisible: {
            get() {
                return this.attachCfg.visible;
            },
            set(newVal) {
                this.attachCfg.visible = newVal;
                this.$emit("update:attachCfg.visible", newVal);
            }
        }
    },
    watch: {
        attachCfg: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal.visible) {
                    this.fileList = [];
                    if (newVal.fkvalue !== null && newVal.fkvalue !== undefined && newVal.fkvalue !== "") {
                        this.queryAttachFileList();
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {},
    methods: {
        queryAttachFileList() {
            this.queryParams.fkvalue = this.attachCfg.fkvalue;
            this.queryParams.fktable = this.attachCfg.fktable;
            this.queryParams.djid = this.attachCfg.djid;
            this.$FG_http
                .post(
                    "./api/main/attach/queryAttach",
                    {
                        queryParams: this.queryParams
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.fileList = data.data.attach;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002");
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.$FG_message.error("P0002");
                    }
                });
        },
        changeAttachtype() {
            let attachtype = this.attachtype === "upload" ? "download" : "upload";
            this.$emit("update:attachtype", attachtype);
        },
        onSearch() {
            this.queryParams.filename = this.searchvalue;
            this.fileList = [];
            this.queryAttachFileList();
        },
        handlePreview(row) {
            this.file = {
                uid: row.id,
                name: row.filename
            };
            this.$FG_http
                .post(
                    "./api/main/attach/previewAttach",
                    {
                        id: row.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let binaryData = [];
                        binaryData.push(data);
                        this.file.url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                        window.open(this.file.url, this.file.name);
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        handleDownload(row) {
            this.$FG_http
                .post(
                    "./api/main/attach/downloadAttach",
                    {
                        id: row.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let aLink = document.createElement("a");
                        let blob = new Blob([data]);
                        aLink.href = URL.createObjectURL(blob);
                        aLink.setAttribute("download", row.filename); // 设置下载文件名称
                        aLink.click(); //执行下载
                        document.body.appendChild(aLink);
                        URL.revokeObjectURL(aLink.href); //释放url
                        document.body.removeChild(aLink); //释放标签
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        handleOk() {
            this.editVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.attactpanel {
    padding: 5px 10px;
    display: flex;
    flex-flow: column;
    .attachtitle {
        color: #333;
        font-size: 24px;
        font-weight: bold;
        .attachicon {
            float: right;
            cursor: pointer;
        }
    }
    .attachserch {
        margin: 1em 0 0 0;
    }
    .attachbtn {
        text-align: right;
    }
    .attachfilelist {
        margin: 10px 0;
    }
}
</style>
